import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../services/api";
import Header from "../components/Header";
import Loader from "../components/Loader";
import Footer from "../components/Footer";
import PhoneField from "../components/PhoneField";
import AddressSuggest from "../components/AddressSuggest";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";
import "../styles/order-form.css";
import "../styles/phone.css";

const OrderDetail = () => {
  const { id } = useParams();
  console.log("OrderDetail id from params:", id);
  const navigate = useNavigate();

  // Основные данные
  const [order, setOrder] = useState(null);
  const [client, setClient] = useState(null);
  const [finance, setFinance] = useState(null);
  const [installers, setInstallers] = useState([]);

  // Списки связанных сущностей
  const [items, setItems] = useState([]);
  const [orderInstallers, setOrderInstallers] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [payments, setPayments] = useState([]);
  const [claims, setClaims] = useState([]);

  // Состояния для форм добавления
  const [showAddItem, setShowAddItem] = useState(false);
  const [showAddInstaller, setShowAddInstaller] = useState(false);
  const [showAddExpense, setShowAddExpense] = useState(false);
  const [showAddPayment, setShowAddPayment] = useState(false);
  const [showAddClaim, setShowAddClaim] = useState(false);

  // Данные для новых записей
  const [newItem, setNewItem] = useState({
    item_type: "product",
    name: "",
    quantity: "1",
    purchase_price: "",
    sale_price: "",
    warranty_manufacturer: "",
  });

  const [newOrderInstaller, setNewOrderInstaller] = useState({
    installer_id: "",
    role: "",
    base_payment: "",
    is_primary: false,
  });

  const [newExpense, setNewExpense] = useState({
    amount: "",
    description: "",
    expense_date: new Date().toISOString().split("T")[0],
    category: "other",
  });

  const [newPayment, setNewPayment] = useState({
    payment_type: "client",
    installer_id: "",
    amount: "",
    payment_date: new Date().toISOString().split("T")[0],
    description: "",
  });

  const [newClaim, setNewClaim] = useState({
    order_item_id: "",
    claim_date: new Date().toISOString().split("T")[0],
    description: "",
    fault_type: "manufacturer",
    responsible_installer_id: "",
    resolution: "",
    resolving_installer_id: "",
    cost: "",
    cost_covered_by: "oleg",
    status: "open",
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching order with id:", id);
        const [orderData, installersData] = await Promise.all([
          api.getOrder(id),
          api.getInstallers(),
        ]);
        console.log("Order data received:", orderData);
        setOrder(orderData);
        setClient(orderData.client || null);
        setFinance(orderData.finance || null);
        setItems(orderData.items || []);
        setOrderInstallers(orderData.installers || []);
        setExpenses(orderData.expenses || []);
        setPayments(orderData.payments || []);
        setClaims(orderData.warranty_claims || []);
        setInstallers(installersData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleOrderChange = (e) => {
    const { name, value } = e.target;
    setOrder((prev) => ({ ...prev, [name]: value }));
  };

  const handleClientChange = (e) => {
    const { name, value } = e.target;
    setClient((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    setClient((prev) => ({ ...prev, phone: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      if (client?.id) {
        await api.updateClient(client.id, {
          full_name: client.full_name,
          phone: client.phone,
          backup_phone: client.backup_phone,
          address: client.address,
          comments: client.comments,
        });
      }

      const orderData = {
        client_id: client?.id,
        status: order.status,
        service_datetime: order.service_datetime,
        promise: order.promise,
        marker_color: order.marker_color,
        address_text: order.address_text,
      };

      if (order.delivery_datetime) {
        orderData.delivery_datetime = order.delivery_datetime;
      }

      console.log("Отправляемые данные заказа:", orderData);

      await api.updateOrder(order.id, orderData);
      alert("Заказ обновлён");
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Удалить заказ?")) {
      try {
        await api.deleteOrder(id);
        navigate("/orders");
      } catch (err) {
        setError(err.message);
      }
    }
  };

  // ---------- Работа с позициями ----------
  const handleAddItem = async () => {
    try {
      const itemData = {
        order_id: order.id,
        item_type: newItem.item_type,
        name: newItem.name,
        quantity: newItem.quantity === "" ? 1 : parseInt(newItem.quantity) || 1,
        purchase_price: newItem.purchase_price === "" ? 0 : parseFloat(newItem.purchase_price) || 0,
        sale_price: newItem.sale_price === "" ? 0 : parseFloat(newItem.sale_price) || 0,
        warranty_manufacturer: newItem.warranty_manufacturer === "" ? 0 : parseInt(newItem.warranty_manufacturer) || 0,
        warranty_master: 0,
        sort_order: items.length,
      };
      const created = await api.createOrderItem(itemData);
      setItems([...items, created]);
      setShowAddItem(false);
      setNewItem({
        item_type: "product",
        name: "",
        quantity: "1",
        purchase_price: "",
        sale_price: "",
        warranty_manufacturer: "",
      });
    } catch (err) {
      alert("Ошибка при добавлении позиции: " + err.message);
    }
  };

  const handleDeleteItem = async (itemId) => {
    if (window.confirm("Удалить позицию?")) {
      try {
        await api.deleteOrderItem(itemId);
        setItems(items.filter((i) => i.id !== itemId));
      } catch (err) {
        alert("Ошибка удаления: " + err.message);
      }
    }
  };

  // ---------- Работа с монтажниками в заказе ----------
  const handleAddOrderInstaller = async () => {
    try {
      const installerData = {
        order_id: order.id,
        installer_id: newOrderInstaller.installer_id,
        role: newOrderInstaller.role,
        base_payment: newOrderInstaller.base_payment === "" ? 0 : parseFloat(newOrderInstaller.base_payment) || 0,
        is_primary: newOrderInstaller.is_primary,
      };
      const created = await api.createOrderInstaller(installerData);
      setOrderInstallers([...orderInstallers, created]);
      setShowAddInstaller(false);
      setNewOrderInstaller({
        installer_id: "",
        role: "",
        base_payment: "",
        is_primary: false,
      });
    } catch (err) {
      alert("Ошибка при назначении монтажника: " + err.message);
    }
  };

  const handleDeleteOrderInstaller = async (installerId) => {
    if (window.confirm("Удалить монтажника из заказа?")) {
      try {
        await api.deleteOrderInstaller(installerId);
        setOrderInstallers(orderInstallers.filter((oi) => oi.id !== installerId));
      } catch (err) {
        alert("Ошибка удаления: " + err.message);
      }
    }
  };

  // ---------- Работа с расходами ----------
  const handleAddExpense = async () => {
    try {
      const expenseData = {
        order_id: order.id,
        amount: newExpense.amount === "" ? 0 : parseFloat(newExpense.amount) || 0,
        description: newExpense.description,
        expense_date: newExpense.expense_date,
        category: newExpense.category,
      };
      const created = await api.createOrderExpense(expenseData);
      setExpenses([...expenses, created]);
      setShowAddExpense(false);
      setNewExpense({
        amount: "",
        description: "",
        expense_date: new Date().toISOString().split("T")[0],
        category: "other",
      });
    } catch (err) {
      alert("Ошибка при добавлении расхода: " + err.message);
    }
  };

  const handleDeleteExpense = async (expenseId) => {
    if (window.confirm("Удалить расход?")) {
      try {
        await api.deleteOrderExpense(expenseId);
        setExpenses(expenses.filter((e) => e.id !== expenseId));
      } catch (err) {
        alert("Ошибка удаления: " + err.message);
      }
    }
  };

  // ---------- Работа с платежами ----------
  const handleAddPayment = async () => {
    try {
      const paymentData = {
        order_id: order.id,
        payment_type: newPayment.payment_type,
        installer_id: newPayment.installer_id || null,
        amount: newPayment.amount === "" ? 0 : parseFloat(newPayment.amount) || 0,
        payment_date: newPayment.payment_date,
        description: newPayment.description,
      };
      const created = await api.createPayment(paymentData);
      setPayments([...payments, created]);
      setShowAddPayment(false);
      setNewPayment({
        payment_type: "client",
        installer_id: "",
        amount: "",
        payment_date: new Date().toISOString().split("T")[0],
        description: "",
      });
    } catch (err) {
      alert("Ошибка при добавлении платежа: " + err.message);
    }
  };

  const handleDeletePayment = async (paymentId) => {
    if (window.confirm("Удалить платёж?")) {
      try {
        await api.deletePayment(paymentId);
        setPayments(payments.filter((p) => p.id !== paymentId));
      } catch (err) {
        alert("Ошибка удаления: " + err.message);
      }
    }
  };

  // ---------- Работа с гарантийными случаями ----------
  const handleAddClaim = async () => {
    if (!newClaim.order_item_id) {
      alert("Выберите позицию");
      return;
    }
    try {
      const claimData = {
        order_item_id: newClaim.order_item_id,
        claim_date: newClaim.claim_date,
        description: newClaim.description,
        fault_type: newClaim.fault_type,
        responsible_installer_id: newClaim.responsible_installer_id || null,
        resolution: newClaim.resolution,
        resolving_installer_id: newClaim.resolving_installer_id || null,
        cost: newClaim.cost === "" ? 0 : parseFloat(newClaim.cost) || 0,
        cost_covered_by: newClaim.cost_covered_by,
        status: newClaim.status,
      };
      const created = await api.createWarrantyClaim(claimData);
      setClaims([...claims, created]);
      setShowAddClaim(false);
      setNewClaim({
        order_item_id: "",
        claim_date: new Date().toISOString().split("T")[0],
        description: "",
        fault_type: "manufacturer",
        responsible_installer_id: "",
        resolution: "",
        resolving_installer_id: "",
        cost: "",
        cost_covered_by: "oleg",
        status: "open",
      });
    } catch (err) {
      alert("Ошибка при добавлении гарантийного случая: " + err.message);
    }
  };

  const handleDeleteClaim = async (claimId) => {
    if (window.confirm("Удалить гарантийный случай?")) {
      try {
        await api.deleteWarrantyClaim(claimId);
        setClaims(claims.filter((c) => c.id !== claimId));
      } catch (err) {
        alert("Ошибка удаления: " + err.message);
      }
    }
  };

  if (loading)
    return (
      <div className="page">
        <Header />
        <main className="content">
          <Loader />
        </main>
        <Footer />
      </div>
    );
  if (error) return <div>Ошибка: {error}</div>;
  if (!order || !client) return <div>Заказ не найден</div>;

  return (
    <div className="page">
      <Header />
      <main className="content">
        <form onSubmit={handleSubmit} className="crm-form">
          <div className="crm-form__header-info">
            <Link to="/orders" className="crm-form__back-link">
              ← Вернуться в журнал
            </Link>
            <h2 className="crm-form__main-title">
              Редактирование заказа №<span>{order.id}</span>
            </h2>
          </div>

          {/* Основные данные заказа и клиента */}
          <fieldset className="crm-form__section">
            <legend className="crm-form__legend">👤 Данные клиента</legend>
            <div className="crm-form__grid">
              <div className="crm-form__field">
                <label>ФИО клиента</label>
                <input
                  type="text"
                  name="full_name"
                  value={client.full_name || ""}
                  onChange={handleClientChange}
                  className="crm-form__input"
                />
              </div>
              <PhoneField
                id="client_phone"
                name="phone"
                value={client.phone || ""}
                onChange={handlePhoneChange}
                label="Телефон"
              />
              <PhoneField
                id="client_backup_phone"
                name="backup_phone"
                value={client.backup_phone || ""}
                onChange={(value) =>
                  setClient((prev) => ({ ...prev, backup_phone: value }))
                }
                label="Резервный телефон"
              />
              <div className="crm-form__field crm-form__field--full">
                <label>Адрес заказа</label>
                <AddressSuggest
                  name="address_text"
                  value={order.address_text || ""}
                  onChange={(e) =>
                    setOrder((prev) => ({
                      ...prev,
                      address_text: e.target.value,
                    }))
                  }
                  className="crm-form__input"
                  placeholder="Начните вводить адрес..."
                />
              </div>
              <div className="crm-form__field">
                <label>Статус заказа</label>
                <select
                  name="status"
                  value={order.status || ""}
                  onChange={handleOrderChange}
                  className="crm-form__input"
                >
                  <option value="Новый">Новый</option>
                  <option value="Ждет установщика">Ждет установщика</option>
                  <option value="В работе">В работе</option>
                  <option value="Выполнен">Выполнен</option>
                  <option value="Отказ">Отказ</option>
                </select>
              </div>
              <div className="crm-form__field">
                <label>Дата и время обслуживания</label>
                <input
                  type="datetime-local"
                  name="service_datetime"
                  value={order.service_datetime?.slice(0, 16) || ""}
                  onChange={handleOrderChange}
                  className="crm-form__input"
                />
              </div>
              <div className="crm-form__field">
                <label>Дата и время доставки</label>
                <div
                  style={{ display: "flex", gap: "8px", alignItems: "center" }}
                >
                  <input
                    type="datetime-local"
                    name="delivery_datetime"
                    value={order.delivery_datetime?.slice(0, 16) || ""}
                    onChange={handleOrderChange}
                    className="crm-form__input"
                    style={{ flex: 1 }}
                  />
                  {order.delivery_datetime && (
                    <button
                      type="button"
                      onClick={() => {
                        setOrder((prev) => ({
                          ...prev,
                          delivery_datetime: null,
                        }));
                      }}
                      style={{
                        background: "#f87171",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        width: "32px",
                        height: "32px",
                        cursor: "pointer",
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Очистить дату"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </div>
              <div className="crm-form__field crm-form__field--full">
                <label>Обещания</label>
                <textarea
                  name="promise"
                  value={order.promise || ""}
                  onChange={handleOrderChange}
                  className="crm-form__input"
                  rows="3"
                />
              </div>
              <div className="crm-form__field crm-form__field--full">
                <label>Комментарии</label>
                <textarea
                  name="comments"
                  value={client.comments || ""}
                  onChange={handleClientChange}
                  className="crm-form__input"
                  rows="3"
                />
              </div>
            </div>
          </fieldset>

          {/* Финансовая сводка (только для просмотра) */}
          {finance && (
            <fieldset className="crm-form__section crm-form__section--finance">
              <legend className="crm-form__legend">💰 Финансовая сводка</legend>
              <div className="crm-form__grid">
                <div className="crm-form__field">
                  <label>Выручка</label>
                  <div className="crm-form__static-value">
                    {finance.revenue != null
                      ? Number(finance.revenue).toFixed(2)
                      : "0.00"}{" "}
                    ₽
                  </div>
                </div>
                <div className="crm-form__field">
                  <label>Себестоимость</label>
                  <div className="crm-form__static-value">
                    {finance.cost_of_goods != null
                      ? Number(finance.cost_of_goods).toFixed(2)
                      : "0.00"}{" "}
                    ₽
                  </div>
                </div>
                <div className="crm-form__field">
                  <label>Выплаты монтажникам</label>
                  <div className="crm-form__static-value">
                    {finance.installer_payments != null
                      ? Number(finance.installer_payments).toFixed(2)
                      : "0.00"}{" "}
                    ₽
                  </div>
                </div>
                <div className="crm-form__field">
                  <label>Расходы</label>
                  <div className="crm-form__static-value">
                    {finance.expenses != null
                      ? Number(finance.expenses).toFixed(2)
                      : "0.00"}{" "}
                    ₽
                  </div>
                </div>
                <div className="crm-form__field">
                  <label>Прибыль</label>
                  <div
                    className="crm-form__static-value"
                    style={{
                      fontWeight: "bold",
                      color:
                        (finance.profit != null ? Number(finance.profit) : 0) >=
                        0
                          ? "#10b981"
                          : "#ef4444",
                    }}
                  >
                    {finance.profit != null
                      ? Number(finance.profit).toFixed(2)
                      : "0.00"}{" "}
                    ₽
                  </div>
                </div>
              </div>
            </fieldset>
          )}

          {/* Карта с меткой заказа */}
          {order.lat && order.lon && (
            <fieldset className="crm-form__section">
              <legend className="crm-form__legend">📍 Карта</legend>
              <div className="order-map-wrapper">
                <YMaps>
                  <Map
                    defaultState={{ center: [order.lat, order.lon], zoom: 15 }}
                    width="100%"
                    height="100%"
                    options={{ suppressMapOpenBlock: true }}
                  >
                    <Placemark geometry={[order.lat, order.lon]} />
                  </Map>
                </YMaps>
              </div>
            </fieldset>
          )}

          {/* Позиции заказа */}
          <fieldset className="crm-form__section">
            <legend className="crm-form__legend">📦 Позиции заказа</legend>
            {items.length === 0 && <p>Нет позиций</p>}
            {items.map((item) => (
              <div
                key={item.id}
                className="item-block"
                style={{
                  border: "1px solid var(--border-color)",
                  padding: "10px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <strong>{item.name}</strong> (
                    {item.item_type === "product" ? "Товар" : "Услуга"})<br />
                    Кол-во: {item.quantity}, закупка: {item.purchase_price} ₽,
                    {item.item_type === "product" ? " продажа" : " цена"}:{" "}
                    {item.sale_price} ₽<br />
                    Гарантия: {item.warranty_manufacturer} лет
                  </div>
                  <button
                    type="button"
                    onClick={() => handleDeleteItem(item.id)}
                    className="item-remove-btn"
                  >
                    ✕
                  </button>
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={() => setShowAddItem(!showAddItem)}
              className="crm-form__button crm-form__button--secondary"
            >
              {showAddItem ? "Отмена" : "➕ Добавить позицию"}
            </button>
            {showAddItem && (
              <div
                className="add-form"
                style={{
                  marginTop: "15px",
                  padding: "15px",
                  border: "1px solid var(--border-color)",
                  borderRadius: "8px",
                }}
              >
                <h4>Новая позиция</h4>
                <div className="crm-form__grid">
                  <div className="crm-form__field">
                    <label>Тип</label>
                    <select
                      value={newItem.item_type}
                      onChange={(e) =>
                        setNewItem({ ...newItem, item_type: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="product">Товар</option>
                      <option value="service">Услуга</option>
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Название *</label>
                    <input
                      type="text"
                      value={newItem.name}
                      onChange={(e) =>
                        setNewItem({ ...newItem, name: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Количество</label>
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={newItem.quantity}
                      onChange={(e) =>
                        setNewItem({ ...newItem, quantity: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  {newItem.item_type === "product" && (
                    <div className="crm-form__field">
                      <label>Закупка (₽)</label>
                      <input
                        type="text"
                        inputMode="decimal"
                        pattern="[0-9]*[.,]?[0-9]*"
                        value={newItem.purchase_price}
                        onChange={(e) =>
                          setNewItem({ ...newItem, purchase_price: e.target.value })
                        }
                        className="crm-form__input"
                      />
                    </div>
                  )}
                  <div className="crm-form__field">
                    <label>
                      {newItem.item_type === "product" ? "Продажа (₽)" : "Цена (₽)"}
                    </label>
                    <input
                      type="text"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]*"
                      value={newItem.sale_price}
                      onChange={(e) =>
                        setNewItem({ ...newItem, sale_price: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Гарантия (лет)</label>
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={newItem.warranty_manufacturer}
                      onChange={(e) =>
                        setNewItem({ ...newItem, warranty_manufacturer: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleAddItem}
                  className="crm-form__button crm-form__button--submit"
                  style={{ marginTop: "10px" }}
                >
                  Сохранить
                </button>
              </div>
            )}
          </fieldset>

          {/* Монтажники в заказе */}
          <fieldset className="crm-form__section">
            <legend className="crm-form__legend">👥 Монтажники</legend>
            {orderInstallers.length === 0 && <p>Нет назначенных монтажников</p>}
            {orderInstallers.map((oi) => {
              const inst = installers.find((i) => i.id === oi.installer_id);
              return (
                <div
                  key={oi.id}
                  className="item-block"
                  style={{
                    border: "1px solid var(--border-color)",
                    padding: "10px",
                    marginBottom: "10px",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <strong>{inst?.full_name || "Неизвестный"}</strong>{" "}
                      {oi.is_primary && "⭐"}
                      <br />
                      Роль: {oi.role}, оплата: {oi.base_payment} ₽
                    </div>
                    <button
                      type="button"
                      onClick={() => handleDeleteOrderInstaller(oi.id)}
                      className="item-remove-btn"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              );
            })}
            <button
              type="button"
              onClick={() => setShowAddInstaller(!showAddInstaller)}
              className="crm-form__button crm-form__button--secondary"
            >
              {showAddInstaller ? "Отмена" : "➕ Назначить монтажника"}
            </button>
            {showAddInstaller && (
              <div
                className="add-form"
                style={{
                  marginTop: "15px",
                  padding: "15px",
                  border: "1px solid var(--border-color)",
                  borderRadius: "8px",
                }}
              >
                <h4>Назначить монтажника</h4>
                <div className="crm-form__grid">
                  <div className="crm-form__field">
                    <label>Монтажник *</label>
                    <select
                      value={newOrderInstaller.installer_id}
                      onChange={(e) =>
                        setNewOrderInstaller({
                          ...newOrderInstaller,
                          installer_id: e.target.value,
                        })
                      }
                      className="crm-form__input"
                      required
                    >
                      <option value="">-- Выберите --</option>
                      {installers.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.full_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Роль *</label>
                    <input
                      type="text"
                      value={newOrderInstaller.role}
                      onChange={(e) =>
                        setNewOrderInstaller({
                          ...newOrderInstaller,
                          role: e.target.value,
                        })
                      }
                      className="crm-form__input"
                      required
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Оплата (₽)</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]*"
                      value={newOrderInstaller.base_payment}
                      onChange={(e) =>
                        setNewOrderInstaller({
                          ...newOrderInstaller,
                          base_payment: e.target.value,
                        })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div
                    className="crm-form__field"
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={newOrderInstaller.is_primary}
                        onChange={(e) =>
                          setNewOrderInstaller({
                            ...newOrderInstaller,
                            is_primary: e.target.checked,
                          })
                        }
                      />{" "}
                      Основной
                    </label>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleAddOrderInstaller}
                  className="crm-form__button crm-form__button--submit"
                  style={{ marginTop: "10px" }}
                >
                  Назначить
                </button>
              </div>
            )}
          </fieldset>

          {/* Расходы */}
          <fieldset className="crm-form__section">
            <legend className="crm-form__legend">
              💸 Непредвиденные расходы
            </legend>
            {expenses.length === 0 && <p>Нет расходов</p>}
            {expenses.map((exp) => (
              <div
                key={exp.id}
                className="item-block"
                style={{
                  border: "1px solid var(--border-color)",
                  padding: "10px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <strong>{exp.description || "Без описания"}</strong>
                    <br />
                    Сумма: {exp.amount} ₽, дата: {exp.expense_date}, категория:{" "}
                    {exp.category}
                  </div>
                  <button
                    type="button"
                    onClick={() => handleDeleteExpense(exp.id)}
                    className="item-remove-btn"
                  >
                    ✕
                  </button>
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={() => setShowAddExpense(!showAddExpense)}
              className="crm-form__button crm-form__button--secondary"
            >
              {showAddExpense ? "Отмена" : "➕ Добавить расход"}
            </button>
            {showAddExpense && (
              <div
                className="add-form"
                style={{
                  marginTop: "15px",
                  padding: "15px",
                  border: "1px solid var(--border-color)",
                  borderRadius: "8px",
                }}
              >
                <h4>Новый расход</h4>
                <div className="crm-form__grid">
                  <div className="crm-form__field">
                    <label>Сумма (₽) *</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]*"
                      value={newExpense.amount}
                      onChange={(e) =>
                        setNewExpense({ ...newExpense, amount: e.target.value })
                      }
                      className="crm-form__input"
                      required
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Описание</label>
                    <input
                      type="text"
                      value={newExpense.description}
                      onChange={(e) =>
                        setNewExpense({ ...newExpense, description: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Дата</label>
                    <input
                      type="date"
                      value={newExpense.expense_date}
                      onChange={(e) =>
                        setNewExpense({ ...newExpense, expense_date: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Категория</label>
                    <select
                      value={newExpense.category}
                      onChange={(e) =>
                        setNewExpense({ ...newExpense, category: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="materials">Материалы</option>
                      <option value="tools">Инструменты</option>
                      <option value="transport">Транспорт</option>
                      <option value="other">Прочее</option>
                    </select>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleAddExpense}
                  className="crm-form__button crm-form__button--submit"
                  style={{ marginTop: "10px" }}
                >
                  Добавить
                </button>
              </div>
            )}
          </fieldset>

          {/* Платежи */}
          <fieldset className="crm-form__section">
            <legend className="crm-form__legend">💳 Платежи</legend>
            {payments.length === 0 && <p>Нет платежей</p>}
            {payments.map((pay) => (
              <div
                key={pay.id}
                className="item-block"
                style={{
                  border: "1px solid var(--border-color)",
                  padding: "10px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <strong>
                      {pay.payment_type === "client"
                        ? "Оплата клиента"
                        : "Выплата монтажнику"}
                    </strong>
                    <br />
                    Сумма: {pay.amount} ₽, дата: {pay.payment_date}
                    {pay.installer_id &&
                      `, монтажник: ${installers.find((i) => i.id === pay.installer_id)?.full_name || ""}`}
                    {pay.description && ` (${pay.description})`}
                  </div>
                  <button
                    type="button"
                    onClick={() => handleDeletePayment(pay.id)}
                    className="item-remove-btn"
                  >
                    ✕
                  </button>
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={() => setShowAddPayment(!showAddPayment)}
              className="crm-form__button crm-form__button--secondary"
            >
              {showAddPayment ? "Отмена" : "➕ Добавить платёж"}
            </button>
            {showAddPayment && (
              <div
                className="add-form"
                style={{
                  marginTop: "15px",
                  padding: "15px",
                  border: "1px solid var(--border-color)",
                  borderRadius: "8px",
                }}
              >
                <h4>Новый платёж</h4>
                <div className="crm-form__grid">
                  <div className="crm-form__field">
                    <label>Тип *</label>
                    <select
                      value={newPayment.payment_type}
                      onChange={(e) =>
                        setNewPayment({ ...newPayment, payment_type: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="client">От клиента</option>
                      <option value="installer">Монтажнику</option>
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Сумма (₽) *</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]*"
                      value={newPayment.amount}
                      onChange={(e) =>
                        setNewPayment({ ...newPayment, amount: e.target.value })
                      }
                      className="crm-form__input"
                      required
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Дата</label>
                    <input
                      type="date"
                      value={newPayment.payment_date}
                      onChange={(e) =>
                        setNewPayment({ ...newPayment, payment_date: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  {newPayment.payment_type === "installer" && (
                    <div className="crm-form__field">
                      <label>Монтажник</label>
                      <select
                        value={newPayment.installer_id}
                        onChange={(e) =>
                          setNewPayment({ ...newPayment, installer_id: e.target.value })
                        }
                        className="crm-form__input"
                      >
                        <option value="">-- Не выбран --</option>
                        {installers.map((i) => (
                          <option key={i.id} value={i.id}>
                            {i.full_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="crm-form__field crm-form__field--full">
                    <label>Описание</label>
                    <input
                      type="text"
                      value={newPayment.description}
                      onChange={(e) =>
                        setNewPayment({ ...newPayment, description: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleAddPayment}
                  className="crm-form__button crm-form__button--submit"
                  style={{ marginTop: "10px" }}
                >
                  Добавить
                </button>
              </div>
            )}
          </fieldset>

          {/* Гарантийные случаи */}
          <fieldset className="crm-form__section">
            <legend className="crm-form__legend">🛡 Гарантийные случаи</legend>
            {claims.length === 0 && <p>Нет гарантийных случаев</p>}
            {claims.map((claim) => {
              const item = items.find((i) => i.id === claim.order_item_id);
              const responsible = installers.find(
                (i) => i.id === claim.responsible_installer_id,
              );
              const resolver = installers.find(
                (i) => i.id === claim.resolving_installer_id,
              );
              return (
                <div
                  key={claim.id}
                  className="item-block"
                  style={{
                    border: "1px solid var(--border-color)",
                    padding: "10px",
                    marginBottom: "10px",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <strong>{claim.description || "Без описания"}</strong>
                      <br />
                      Позиция: {item?.name || "неизвестно"}
                      <br />
                      Дата: {claim.claim_date}, тип: {claim.fault_type}
                      <br />
                      Ответственный: {responsible?.full_name || "не указан"}
                      <br />
                      Решение: {claim.resolution || "нет"}, исполнитель:{" "}
                      {resolver?.full_name || "не указан"}
                      <br />
                      Стоимость: {claim.cost} ₽, покрывает:{" "}
                      {claim.cost_covered_by}, статус: {claim.status}
                    </div>
                    <button
                      type="button"
                      onClick={() => handleDeleteClaim(claim.id)}
                      className="item-remove-btn"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              );
            })}
            <button
              type="button"
              onClick={() => setShowAddClaim(!showAddClaim)}
              className="crm-form__button crm-form__button--secondary"
            >
              {showAddClaim ? "Отмена" : "➕ Добавить гарантийный случай"}
            </button>
            {showAddClaim && (
              <div
                className="add-form"
                style={{
                  marginTop: "15px",
                  padding: "15px",
                  border: "1px solid var(--border-color)",
                  borderRadius: "8px",
                }}
              >
                <h4>Новый гарантийный случай</h4>
                <div className="crm-form__grid">
                  <div className="crm-form__field">
                    <label>Позиция *</label>
                    <select
                      value={newClaim.order_item_id}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, order_item_id: e.target.value })
                      }
                      className="crm-form__input"
                      required
                    >
                      <option value="">-- Выберите позицию --</option>
                      {items.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Дата</label>
                    <input
                      type="date"
                      value={newClaim.claim_date}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, claim_date: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Описание</label>
                    <input
                      type="text"
                      value={newClaim.description}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, description: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Тип неисправности</label>
                    <select
                      value={newClaim.fault_type}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, fault_type: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="manufacturer">Производитель</option>
                      <option value="installer">Монтажник</option>
                      <option value="other">Другое</option>
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Ответственный монтажник</label>
                    <select
                      value={newClaim.responsible_installer_id}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, responsible_installer_id: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="">-- Не выбран --</option>
                      {installers.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.full_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Решение</label>
                    <input
                      type="text"
                      value={newClaim.resolution}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, resolution: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Исполнитель</label>
                    <select
                      value={newClaim.resolving_installer_id}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, resolving_installer_id: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="">-- Не выбран --</option>
                      {installers.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.full_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Стоимость (₽)</label>
                    <input
                      type="text"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]*"
                      value={newClaim.cost}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, cost: e.target.value })
                      }
                      className="crm-form__input"
                    />
                  </div>
                  <div className="crm-form__field">
                    <label>Кто покрывает</label>
                    <select
                      value={newClaim.cost_covered_by}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, cost_covered_by: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="oleg">Олег</option>
                      <option value="manufacturer">Производитель</option>
                      <option value="installer">Монтажник</option>
                    </select>
                  </div>
                  <div className="crm-form__field">
                    <label>Статус</label>
                    <select
                      value={newClaim.status}
                      onChange={(e) =>
                        setNewClaim({ ...newClaim, status: e.target.value })
                      }
                      className="crm-form__input"
                    >
                      <option value="open">Открыт</option>
                      <option value="in_progress">В работе</option>
                      <option value="closed">Закрыт</option>
                      <option value="rejected">Отклонён</option>
                    </select>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleAddClaim}
                  className="crm-form__button crm-form__button--submit"
                  style={{ marginTop: "10px" }}
                >
                  Добавить
                </button>
              </div>
            )}
          </fieldset>

          {/* Кнопки действий */}
          <div className="crm-form__actions">
            <button
              type="submit"
              className="crm-form__button crm-form__button--submit"
              disabled={saving}
            >
              {saving ? "💾 Сохранение..." : "💾 Сохранить изменения заказа"}
            </button>
            <button
              type="button"
              className="crm-form__button crm-form__button--delete"
              onClick={handleDelete}
            >
              🗑 Удалить заказ
            </button>
          </div>
        </form>
      </main>
      <Footer />
    </div>
  );
};

export default OrderDetail;